import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { parsePayUResponse } from '../utils/payu';
import './PaymentFailure.css';

function PaymentFailure() {
  const navigate = useNavigate();
  const location = useLocation();
  const [paymentDetails, setPaymentDetails] = useState(null);

  useEffect(() => {
    // Parse URL parameters using utility function
    const response = parsePayUResponse(location.search);

    setPaymentDetails({
      transactionId: response.txnid,
      amount: response.amount,
      courseName: response.productinfo,
      status: response.status,
      errorMessage: response.error_Message || response.field9 || 'Payment transaction failed'
    });
  }, [location.search]);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleRetry = () => {
    navigate('/');
  };

  return (
    <div className="payment-status-container">
      <div className="payment-status-card failure">
        <div className="status-icon failure-icon">✗</div>
        <h2>Payment Failed</h2>
        <p className="failure-message">
          Unfortunately, your payment could not be processed.
        </p>

        {paymentDetails && (
          <div className="payment-details">
            <h3>Transaction Details</h3>
            {paymentDetails.transactionId && (
              <div className="detail-row">
                <span className="detail-label">Transaction ID:</span>
                <span className="detail-value">{paymentDetails.transactionId}</span>
              </div>
            )}
            {paymentDetails.courseName && (
              <div className="detail-row">
                <span className="detail-label">Course:</span>
                <span className="detail-value">{paymentDetails.courseName}</span>
              </div>
            )}
            {paymentDetails.amount && (
              <div className="detail-row">
                <span className="detail-label">Amount:</span>
                <span className="detail-value">₹{paymentDetails.amount}</span>
              </div>
            )}
            {paymentDetails.errorMessage && (
              <div className="detail-row error-detail">
                <span className="detail-label">Reason:</span>
                <span className="detail-value">{paymentDetails.errorMessage}</span>
              </div>
            )}
          </div>
        )}

        <div className="failure-suggestions">
          <h3>Possible Reasons:</h3>
          <ul>
            <li>Insufficient funds in your account</li>
            <li>Incorrect payment details</li>
            <li>Transaction timeout</li>
            <li>Payment cancelled by user</li>
            <li>Technical issue with the payment gateway</li>
          </ul>
        </div>

        <div className="failure-actions">
          <button className="status-button retry-button" onClick={handleRetry}>
            Try Again
          </button>
          <button className="status-button secondary-button" onClick={handleGoHome}>
            Go to Home
          </button>
        </div>

        <p className="support-text">
          If you continue to face issues, please contact our support team with your transaction ID.
        </p>
      </div>
    </div>
  );
}

export default PaymentFailure;
